
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/winter-wonderland-best-ski-trips",
      function () {
        return require("private-next-pages/blog/winter-wonderland-best-ski-trips.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/winter-wonderland-best-ski-trips"])
      });
    }
  